import { connect } from 'react-redux';
import PerformanceDeltasComponent from './../Components/PerformanceDeltasComponent';
import { getMetricsPageSelectedJob, getPerformanceMetrics } from './../reducers';

export const mapStateToProps = (state) => {
  const selected = getMetricsPageSelectedJob(state);
  const jobs = getPerformanceMetrics(state);

  const primary = selected[0] ? jobs[selected[0].index] : undefined;
  const secondary = selected[1] ? jobs[selected[1].index] : undefined;

  const durDelta = primary && secondary ?
    parseFloat(
      100 * (primary.duration - secondary.duration) / secondary.duration
    ).toPrecision(4) :
    0;

  return {
    primaryName: selected[0] ?
      selected[0].value : undefined,
    secondaryName: selected[1] ? selected[1].value : undefined,
    durDelta: `${durDelta > 0 ? '+' : ''}${durDelta}`
  };
};


export default connect(
  mapStateToProps
)(PerformanceDeltasComponent);


// WEBPACK FOOTER //
// src/Containers/PerformanceDeltasContainer.jsx